import { Navigate, useLocation } from "react-router-dom";

export const PrivateRoutes = ({ children }) => {
  const userStr = localStorage.getItem("user");
  const user = userStr ? JSON.parse(userStr) : null;
  const location = useLocation();

  if (!user?.token) {
    return <Navigate to="/" replace={true} />;
  }

  // Cross-role protection logic
  const path = location.pathname;

  // superAdmin can access anything
  if (user.role === "superAdmin") {
    return children;
  }

  if (path.startsWith("/admin") && user.role !== "admin") {
    if (user.role === "merchant") return <Navigate to="/merchant" replace={true} />;
    if (user.role === "deliveryBoy") return <Navigate to="/delivery" replace={true} />;
  }

  if (path.startsWith("/merchant") && user.role !== "merchant") {
    if (user.role === "admin") return <Navigate to="/admin" replace={true} />;
    if (user.role === "deliveryBoy") return <Navigate to="/delivery" replace={true} />;
  }

  if (path.startsWith("/superAdmin") && user.role !== "superAdmin") {
    if (user.role === "admin") return <Navigate to="/admin" replace={true} />;
    if (user.role === "merchant") return <Navigate to="/merchant" replace={true} />;
    if (user.role === "deliveryBoy") return <Navigate to="/delivery" replace={true} />;
  }

  if (path.startsWith("/delivery") && user.role !== "deliveryBoy") {
    if (user.role === "admin") return <Navigate to="/admin" replace={true} />;
    if (user.role === "merchant") return <Navigate to="/merchant" replace={true} />;
  }

  return children;
};
